import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../annotation-handler';

@Component({
    selector: 'app-annotation-dashboard',
    templateUrl: './annotation-dashboard.component.html',
    styleUrls: ['./annotation-dashboard.component.scss'],
    standalone: false
})
export class AnnotationDashboardComponent {

  @Input() curAnn: AnnotationHandler;
  @Input() target;
  @Input() mediaList;

  hideParent() {
    return !this.curAnn.parentObject?.artifact_id;
  }

}
